import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { IS_NO_ACCESS, IS_NOT_AUTHORIZED } from 'constants/typeAccess';
import { LOGIN_PATH } from 'constants/navigation';
import { MATERIAL_TYPES } from 'constants/common';
import { RootAppState } from 'store/types';
import {
  isCourseAccessLimited,
  isProgressRestoreFetched,
  isProgressRestoreFailed
} from 'store/course/selectors';
import { isReviewMode, isPreviewMode } from 'store/settings/selectors';
import { CircleLoader } from 'components/common';
import styled from 'styled-components';

const OverLayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: ${props => props.theme.colors.contentBodyColor};
  z-index: 200;
`;

type PrivateRouteProps = {
  component: any;
  componentNoAccess: any;
  typeAccess: string;
  exact?: any;
  path: any;
  materialType?: string;
  isCourseProgressRestoreFetched?: boolean;
  isCourseProgressRestoreFailed?: boolean;
  courseAccessLimited?: boolean;
  reviewMode?: boolean;
  previewMode?: boolean;
};

export const PrivateRoute = ({
  component: Component,
  componentNoAccess: ComponentNoAccess,
  typeAccess,
  materialType,
  isCourseProgressRestoreFetched,
  isCourseProgressRestoreFailed,
  courseAccessLimited,
  reviewMode,
  previewMode,
  ...rest
}: PrivateRouteProps) => (
  <Route
    {...rest}
    render={props => {
      if (typeAccess === IS_NO_ACCESS) {
        return <ComponentNoAccess {...props} />;
      }
      if (typeAccess === IS_NOT_AUTHORIZED) {
        return <Redirect to={LOGIN_PATH} />;
      }
      if (materialType === MATERIAL_TYPES.COURSE) {
        return courseAccessLimited ||
          reviewMode ||
          previewMode ||
          isCourseProgressRestoreFetched ||
          isCourseProgressRestoreFailed ? (
          <Component {...props} />
        ) : (
          <OverLayContainer>
            <CircleLoader iconSize={96} />
          </OverLayContainer>
        );
      }
      return <Component {...props} />;
    }}
  />
);

function mapStateToProps(state: RootAppState) {
  return {
    isCourseProgressRestoreFetched: isProgressRestoreFetched(state),
    isCourseProgressRestoreFailed: isProgressRestoreFailed(state),
    courseAccessLimited: isCourseAccessLimited(state),
    reviewMode: isReviewMode(state),
    previewMode: isPreviewMode(state)
  };
}

export default connect(mapStateToProps)(PrivateRoute);
